import type { StringIndexedObject } from "@kanda-libs/ks-component-ts";

export const getInitialState = (
  keys: string[]
): StringIndexedObject<boolean> => {
  const params = new URLSearchParams(window.location.search);
  return keys.reduce((state, key) => {
    const urlParam = params.get(key);
    if (!urlParam) return state;
    state[key] = true;
    return state;
  }, {} as StringIndexedObject<boolean>);
};

export const pushStateToQueryParams = (
  push: (path: string, state?: unknown) => void,
  state: StringIndexedObject<boolean>
): void => {
  // Read the current URL state, and only keep values that are set to
  // true as false is the default, so no point in keeping that in URL state
  const formattedState = Object.keys(state).reduce((finalState, value) => {
    if (state[value]) {
      finalState[value] = true;
    }
    return finalState;
  }, {} as StringIndexedObject<boolean>);

  const formattedQueryString = new URLSearchParams(
    formattedState as unknown as StringIndexedObject<string>
  ).toString();

  push(`?${formattedQueryString}`, formattedState);
};
